<template>
<div id="hoshinoresorts">
<!-- =========================================
MAIN
========================================= -->
<div id="hoshino_main" class="hoshino_main">
<img id="hoshino_main_img" class="hoshino_main_img" src="../assets/img/hoshinoresort/hoshino_main2.jpg" alt="">
<img id="hoshino_main_img_mobile" class="hoshino_main_img" src="../assets/img/hoshinoresort/hoshino_main_mobile.jpg" alt="">
</div>

<div id="hoshino_main_under" class="hoshino_main_under">
  <div class="hoshino_main_under_point">
    <img src="../assets/img/hoshinoresort/Point2.png" alt="">
  </div>

  <div class="hoshino_main_under_boxes">
    <img src="../assets/img/hoshinoresort/box1.png" alt="">
    <img src="../assets/img/hoshinoresort/box2.png" alt="">
    <img src="../assets/img/hoshinoresort/box3.png" alt="">
    <img src="../assets/img/hoshinoresort/box4.png" alt="">
  </div>
</div>

<!-- =========================================
TAB BUTTON
========================================= -->
<div v-if="isTabFixed" id="hoshino_tab_placeholder" class="hoshino_tab_placeholder"></div>

<div id="hoshino_tabbutton" class="hoshino_tabbutton" :class="{ hoshino_tab_fixed: isTabFixed }">
<ul id="hoshino_tab_ul" class="hoshino_tab_ul">

<li id="hoshino_tab1" class="hoshino_tab" data-target="hoshino_sec1" @click="selectSec(1, 'hoshino_sec1')">
<img v-if="activeSec === 1" src="../assets/img/hoshinoresort/sec1_button_choice.jpg" alt="">
<img v-else src="../assets/img/hoshinoresort/sec1_button.jpg" alt="">
</li>

<li id="hoshino_tab2" class="hoshino_tab" data-target="hoshino_sec2" @click="selectSec(2, 'hoshino_sec2')">
<img v-if="activeSec === 2" src="../assets/img/hoshinoresort/sec2_button_choice.jpg" alt="">
<img v-else src="../assets/img/hoshinoresort/sec2_button.jpg" alt="">
</li>

<li id="hoshino_tab3" class="hoshino_tab" data-target="hoshino_sec3" @click="selectSec(3, 'hoshino_sec3')">
<img v-if="activeSec === 3" src="../assets/img/hoshinoresort/sec3_button_choice.jpg" alt="">
<img v-else src="../assets/img/hoshinoresort/sec3_button.jpg" alt="">
</li>

</ul>
</div>

<!-- =========================================
SEC 1
========================================= -->
<div id="hoshino_sec1" class="hoshino_section hoshino_section1">

<div id="hoshino_sec1_contents" class="hoshino_sec1_contents">


<img id="hoshino_sec1_img" class="hoshino_sec1_img" src="../assets/img/hoshinoresort/sec3_img.png" alt="" style="margin-bottom: 30px;">
<img id="hoshino_sec1_img" class="hoshino_sec1_img" src="../assets/img/hoshinoresort/Point3.png" alt="" style="margin-top: 50px; margin-bottom: 30px;">

<div id="hoshino_auto_slider" class="hoshino_auto_slider">
<div id="hoshino_auto_track" class="hoshino_auto_track">

<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box.jpg" alt=""></div>
<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box2.jpg" alt=""></div>
<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box3.jpg" alt=""></div>
<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box4.jpg" alt=""></div>
<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box5.jpg" alt=""></div>
<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box6.jpg" alt=""></div>
<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box7.jpg" alt=""></div>
<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box8.jpg" alt=""></div>

<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box.jpg" alt=""></div>
<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box2.jpg" alt=""></div>
<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box3.jpg" alt=""></div>
<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box4.jpg" alt=""></div>
<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box5.jpg" alt=""></div>
<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box6.jpg" alt=""></div>
<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box7.jpg" alt=""></div>
<div class="hoshino_auto_item"><img src="../assets/img/hoshinoresort/sec1_box8.jpg" alt=""></div>

</div>
</div>
</div>
</div>

<div id="hoshino_sec1_bottom2" class="hoshino_sec1_bottom2"></div>

<!-- =========================================
SEC 2
========================================= -->
<div id="hoshino_sec2" class="hoshino_section hoshino_section2">

<div id="hoshino_sec2_main" class="hoshino_sec2_main">

<div id="hoshino_sec2_carousel" class="hoshino_sec2_carousel">

<div class="hoshino_sec2_slide" :class="{ active: activeSec2Slide === 0 }">
<div class="hoshino_sec2_background">
<img v-if="sec2Slides[0]" :src="sec2Slides[0]" alt="" class="hoshino_sec2_img_pc">
<img v-if="sec2SlidesMobile[0]" :src="sec2SlidesMobile[0]" alt="" class="hoshino_sec2_img_mobile">
</div>
<div class="hoshino_sec2_text_panel">
<div class="hoshino_sec2_text_inner">
<span class="hoshino_sec2_text_label">RISONARE SHIMONOSEKI</span>
<h2 class="hoshino_sec2_text_title">호시노 리조트<br>
리조나레 시모노세키</h2>
<p class="hoshino_sec2_text_desc">
112년 역사의 일본 최고급 호텔 그룹 '호시노 리조트'에서<br>
새롭게 선보이는 전 객실 오션뷰 최고급 호텔 <br><span class="" style="font-weight: 900;">'리조나레 시모노세키'</span>
<br><br>

객실에서 누리는 간몬해협 오션뷰.<br>
곡선형의 건축 디자인과 감각적인 실내 인테리어.<br>
어른과 아이가 함께할 수 있는 실내 수영장 FUGU POOL.<br>
잔디밭에서 즐기는 도심속 오션뷰 피크닉 나미나미 테라스.<br>
아이와 함께하는 가족여행을 보다 가치있게 누려보세요.
</p>
</div>
</div>
</div>

<div class="hoshino_sec2_slide" :class="{ active: activeSec2Slide === 1 }">
<div class="hoshino_sec2_background">
<img v-if="sec2Slides[1]" :src="sec2Slides[2]" alt="" class="hoshino_sec2_img_pc">
<img v-if="sec2SlidesMobile[1]" :src="sec2SlidesMobile[1]" alt="" class="hoshino_sec2_img_mobile">
</div>
<div class="hoshino_sec2_text_panel">
<div class="hoshino_sec2_text_inner">
<span class="hoshino_sec2_text_label">FACILITIES & SERVICES</span>
<h5 class="hoshino_sec2_text_title">우리 가족의 완벽한<br>
호캉스를 위한<br>
부대시설 & 서비스 활용 방법</h5>
<p class="hoshino_sec2_text_desc">
1. FUGU POOL 수영장<br>
아이들과 부모님 모두 즐길 수 있는 실내풀<br>
간몬해협을 품은 인피니티풀<br>
부모님의 휴식, 아이의 즐거움을 모두 누려보세요<br><br>

2. 나미나미(NAMI NAMI) 테라스<br>
잔디밭에서 즐기는 오션뷰 피크닉!<br>
시간에 따라 변하는 간몬해협의 풍경을 바라보며<br>
가족들과 색다른 추억을 남겨보세요.<br><br>

3. 키즈케어 서비스<br>
부부만의 시간을 위해 아이는 잠깐만!<br>
아이 걱정은 잠시 내려놓고 걱정없이 여유로운 시간을 가져보세요.<br>
*식사 또는 SPA 이용 고객 대상에게만 제공
</p>
</div>
</div>
</div>

<div class="hoshino_sec2_slide" :class="{ active: activeSec2Slide === 2 }">
<div class="hoshino_sec2_background">
<img v-if="sec2Slides[2]" :src="sec2Slides[1]" alt="" class="hoshino_sec2_img_pc">
<img v-if="sec2SlidesMobile[2]" :src="sec2SlidesMobile[2]" alt="" class="hoshino_sec2_img_mobile">
</div>
<div class="hoshino_sec2_text_panel">
<div class="hoshino_sec2_text_inner">
<span class="hoshino_sec2_text_label">DINING</span>
<h2 class="hoshino_sec2_text_title">다채로운 미식의 시간</h2>
<p class="hoshino_sec2_text_desc">
1. OTTO SETTE SHIMONOSEKI<br>
복어 껍질 카펠리니, 복어 튀김과 껍질 리조또 등<br>
시모노세키의 명물 '복어'를 재해석한 이탈리안 코스 다이닝.<br>
두께에 따라서 변화하는 '복어의 새로운 맛'을 느껴보세요.<br><br>

2. PUKU PUKU 디너 뷔페<br>
복어 가라아게, 복어 슈마이(만두) 등 다채로운 복어요리와<br>
시모노세키만의 매력이 담긴 메뉴들로 구성된 디너 뷔페.<br>
다양한 맛과 식감으로 특별한 미식 경험을 만나보세요.<br><br>

3. PUKU PUKU 모닝 뷔페(기본포함)<br>
복어 육수와 함께 맛보는 가와라소바.<br>
감귤을 활용한 프렌치토스트 등<br>
시모노세키 지역의 식재료를 활용한 아침 뷔페입니다.<br>
신선하고 든든한 아침식사로 하루를 시작해보세요.

</p>
</div>
</div>
</div>

<div class="hoshino_sec2_slide" :class="{ active: activeSec2Slide === 3 }">
<div class="hoshino_sec2_background">
<img v-if="sec2Slides[3]" :src="sec2Slides[3]" alt="" class="hoshino_sec2_img_pc">
<img v-if="sec2SlidesMobile[3]" :src="sec2SlidesMobile[3]" alt="" class="hoshino_sec2_img_mobile">
</div>
<div class="hoshino_sec2_text_panel">
<div class="hoshino_sec2_text_inner">
<span class="hoshino_sec2_text_label">ROOM</span>
<h2 class="hoshino_sec2_text_title">편안한 휴식이 머무는 객실</h2>
<p class="hoshino_sec2_text_desc">
  간몬해협에서 영감을 받은 에메랄드 그린 디자인과<br>
감각적인 인테리어가 돋보이는 객실.<br><br>

눈을 뜨는 순간 펼쳐지는 푸른 간몬해협.<br>
타입 상관 없는 전객실 오션뷰로<br>
시모노세키와 간몬해협의 풍경을 감상해보세요.<br><br>

최대 3인 기준 슈페리어 객실부터<br>
4인 가족을 위한 디럭스쿼드 객실까지<br>
우리 가족에 맞는 맞춤형 객실 선택으로<br>
프라이빗한 시간을 누려보세요.
</p>
</div>
</div>
</div>



</div>

<div id="hoshino_sec2_cards" class="hoshino_sec2_cards">

<button type="button" id="hoshino_sec2_card1" class="hoshino_sec2_card" :class="{ active: activeSec2Slide === 0 }" @click="changeSec2Slide(0)">
<span class="hoshino_sec2_card_red"></span>
<span class="hoshino_sec2_card_content"><strong>호텔 소개</strong></span>
</button>

<button type="button" id="hoshino_sec2_card2" class="hoshino_sec2_card" :class="{ active: activeSec2Slide === 1 }" @click="changeSec2Slide(1)">
<span class="hoshino_sec2_card_red"></span>
<span class="hoshino_sec2_card_content"><strong> 부대시설<br>& 서비스</strong></span>
</button>

<button type="button" id="hoshino_sec2_card3" class="hoshino_sec2_card" :class="{ active: activeSec2Slide === 2 }" @click="changeSec2Slide(2)">
<span class="hoshino_sec2_card_red"></span>
<span class="hoshino_sec2_card_content"><strong>다이닝</strong></span>
</button>

<button type="button" id="hoshino_sec2_card4" class="hoshino_sec2_card" :class="{ active: activeSec2Slide === 3 }" @click="changeSec2Slide(3)">
<span class="hoshino_sec2_card_red"></span>
<span class="hoshino_sec2_card_content"><strong>객실</strong></span>
</button>

</div>
</div>
</div>

<div id="hoshino_sec1_bottom2" class="hoshino_sec1_bottom2"></div>

<!-- =========================================
SEC 3
========================================= -->
<div id="hoshino_sec3" class="hoshino_section hoshino_section2">

<div id="hoshino_sec3_main" class="hoshino_sec3_main">

<div id="hoshino_sec3_carousel" class="hoshino_sec3_carousel">

<div class="hoshino_sec3_slide" :class="{ active: activeSec3Slide === 0 }">
<div class="hoshino_sec3_background">
<img v-if="sec3Slides[0]" :src="sec3Slides[0]" alt="" class="hoshino_sec3_img_pc">
<img v-if="sec3SlidesMobile[0]" :src="sec3SlidesMobile[0]" alt="" class="hoshino_sec3_img_mobile">
</div>
<div class="hoshino_sec3_text_panel">
<div class="hoshino_sec3_text_inner">
<span class="hoshino_sec3_text_label">PUKWAN FERRY</span>
<h2 class="hoshino_sec3_text_title">부관훼리 선박</h2>
<p class="hoshino_sec3_text_desc">
부산과 시모노세키를 잇는 대표적인 한일 국제 여객선으로,
편안하고 여유로운 바다 여행을 제공합니다.
넓고 쾌적한 선내 시설과 다양한 편의 공간을 갖춰 이동 그 이상의
특별한 훼리 여행 감성을 경험할 수 있습니다.
</p>
</div>
</div>
</div>

<div class="hoshino_sec3_slide" :class="{ active: activeSec3Slide === 1 }">
<div class="hoshino_sec3_background">
<img v-if="sec3Slides[1]" :src="sec3Slides[1]" alt="" class="hoshino_sec3_img_pc">
<img v-if="sec3SlidesMobile[1]" :src="sec3SlidesMobile[1]" alt="" class="hoshino_sec3_img_mobile">
</div>
<div class="hoshino_sec3_text_panel">
<div class="hoshino_sec3_text_inner">
<span class="hoshino_sec3_text_label">FACILITIES</span>
<h2 class="hoshino_sec3_text_title">부대시설</h2>
<p class="hoshino_sec3_text_desc">
여행의 즐거움을 더해주는 다양한 선내 부대시설을 만나보세요.
편안한 휴식 공간부터 식사와 여가를 즐길 수 있는 편의시설까지,
이동하는 시간마저 특별한 여행의 한 장면으로 만들어드립니다.
</p>
</div>
</div>
</div>

<div class="hoshino_sec3_slide" :class="{ active: activeSec3Slide === 2 }">
<div class="hoshino_sec3_background">
<img v-if="sec3Slides[2]" :src="sec3Slides[2]" alt="" class="hoshino_sec3_img_pc">
<img v-if="sec3SlidesMobile[2]" :src="sec3SlidesMobile[2]" alt="" class="hoshino_sec3_img_mobile">
</div>
<div class="hoshino_sec3_text_panel">
<div class="hoshino_sec3_text_inner">
<span class="hoshino_sec3_text_label">SHIPBOARD MEAL</span>
<h2 class="hoshino_sec3_text_title">선내 식사</h2>
<p class="hoshino_sec3_text_desc">
바다 위에서 즐기는 특별한 선내식사.<br>
부관훼리에서만 느낄 수 있는 여유로운 바다 풍경과 함께<br>
맛있는 식사를 즐기며 여행의 즐거움을 더욱 풍성하게 채워보세요.
</p>
</div>
</div>
</div>

<div class="hoshino_sec3_slide" :class="{ active: activeSec3Slide === 3 }">
<div class="hoshino_sec3_background">
<img v-if="sec3Slides[3]" :src="sec3Slides[3]" alt="" class="hoshino_sec3_img_pc">
<img v-if="sec3SlidesMobile[3]" :src="sec3SlidesMobile[3]" alt="" class="hoshino_sec3_img_mobile">
</div>
<div class="hoshino_sec3_text_panel">
<div class="hoshino_sec3_text_inner">
<span class="hoshino_sec3_text_label">GUEST ROOM</span>
<h2 class="hoshino_sec3_text_title">객실</h2>
<p class="hoshino_sec3_text_desc">
편안한 휴식과 함께 즐기는 특별한 바다 위의 하룻밤
쾌적하고 다양한 객실에서 여유롭게 휴식을 취하며,
부산과 시모노세키를 잇는 바다 여행의 낭만을 온전히 느껴보세요.
</p>
</div>
</div>
</div>



</div>

<div id="hoshino_sec3_cards" class="hoshino_sec3_cards">

<button type="button" id="hoshino_sec3_card1" class="hoshino_sec3_card" :class="{ active: activeSec3Slide === 0 }" @click="changeSec3Slide(0)">
<span class="hoshino_sec3_card_red"></span>
<span class="hoshino_sec3_card_content"><strong>부관훼리 소개</strong></span>
</button>

<button type="button" id="hoshino_sec3_card2" class="hoshino_sec3_card" :class="{ active: activeSec3Slide === 1 }" @click="changeSec3Slide(1)">
<span class="hoshino_sec3_card_red"></span>
<span class="hoshino_sec3_card_content"><strong>부대시설</strong></span>
</button>

<button type="button" id="hoshino_sec3_card3" class="hoshino_sec3_card" :class="{ active: activeSec3Slide === 2 }" @click="changeSec3Slide(2)">
<span class="hoshino_sec3_card_red"></span>
<span class="hoshino_sec3_card_content"><strong>선내식사</strong></span>
</button>

<button type="button" id="hoshino_sec3_card4" class="hoshino_sec3_card" :class="{ active: activeSec3Slide === 3 }" @click="changeSec3Slide(3)">
<span class="hoshino_sec3_card_red"></span>
<span class="hoshino_sec3_card_content"><strong>객실</strong></span>
</button>

</div>
</div>

<div id="hoshino_sec3_bottom" class="hoshino_sec3_bottom" style="background-color: #ddcfc1;">
<div id="hoshino_button_wrap" class="hoshino_button_wrap">
<a id="hoshino_button" style="color: #3f2205;" class="hoshino_button" href="https://ntabi.co.kr/detail?productId=T-2026814-1786685673075&salesRoute=T">상품 바로가기</a>
</div>
</div>

</div>
</div>
</template>

<script>
export default {
data() {
return {
activeSec: 1,
isTabFixed: false,
tabOffsetTop: 0,
tabHeight: 100,
activeSec2Slide: 0,
activeSec3Slide: 0,
sec3Slides: [
require('../assets/img/hoshinoresort/sec3_slide1.jpg'),
require('../assets/img/hoshinoresort/sec3_slide2.jpg'),
require('../assets/img/hoshinoresort/sec3_slide3.jpg'),
require('../assets/img/hoshinoresort/sec3_slide4.jpg'),
],
sec2Slides: [
require('../assets/img/hoshinoresort/slide1.jpg'),
require('../assets/img/hoshinoresort/slide2.jpg'),
require('../assets/img/hoshinoresort/slide3.jpg'),
require('../assets/img/hoshinoresort/slide4.jpg'),
],
sec2SlidesMobile: [
require('../assets/img/hoshinoresort/slide1_mobile.jpg'),
require('../assets/img/hoshinoresort/slide2_mobile.jpg'),
require('../assets/img/hoshinoresort/slide3_mobile.jpg'),
require('../assets/img/hoshinoresort/slide4_mobile.jpg')
],
sec3SlidesMobile: [
require('../assets/img/hoshinoresort/sec3_slide1_mobile.jpg'),
require('../assets/img/hoshinoresort/sec3_slide2_mobile.jpg'),
require('../assets/img/hoshinoresort/sec3_slide3_mobile.jpg'),
require('../assets/img/hoshinoresort/sec3_slide4_mobile.jpg')
]
}
},
mounted() {
this.$nextTick(() => {
this.setTabPosition()
window.addEventListener('scroll', this.handleTabScroll)
window.addEventListener('resize', this.setTabPosition)
})
},
beforeUnmount() {
window.removeEventListener('scroll', this.handleTabScroll)
window.removeEventListener('resize', this.setTabPosition)
},
methods: {
setTabPosition() {
const tab = document.getElementById('hoshino_tabbutton')
if (!tab) return
this.tabHeight = tab.offsetHeight
if (!this.isTabFixed) {
this.tabOffsetTop = tab.getBoundingClientRect().top + window.pageYOffset
}
},
handleTabScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop
this.updateActiveSec()
if (scrollTop >= this.tabOffsetTop) {
if (!this.isTabFixed) {
this.isTabFixed = true
}
} else {
if (this.isTabFixed) {
this.isTabFixed = false
this.$nextTick(() => {
this.setTabPosition()
})
}
}
},
updateActiveSec() {
const sections = [
{ num: 1, id: 'hoshino_sec1' },
{ num: 2, id: 'hoshino_sec2' },
{ num: 3, id: 'hoshino_sec3' }
]
const checkPoint = this.tabHeight + 20
let currentSec = 1
sections.forEach((item) => {
const section = document.getElementById(item.id)
if (!section) return
const rect = section.getBoundingClientRect()
if (rect.top <= checkPoint) {
currentSec = item.num
}
})
if (this.activeSec !== currentSec) {
this.activeSec = currentSec
}
},
changeSec2Slide(index) {
if (index < 0 || index > 3) return
this.activeSec2Slide = index
},
nextSec2Slide() {
this.activeSec2Slide = (this.activeSec2Slide + 1) % 4
},
prevSec2Slide() {
this.activeSec2Slide = (this.activeSec2Slide - 1 + 4) % 4
},
changeSec3Slide(index) {
if (index < 0 || index > 3) return
this.activeSec3Slide = index
},
nextSec3Slide() {
this.activeSec3Slide = (this.activeSec3Slide + 1) % 4
},
prevSec3Slide() {
this.activeSec3Slide = (this.activeSec3Slide - 1 + 4) % 4
},
selectSec(num, target) {
this.activeSec = num
const section = document.getElementById(target)
if (!section) return
const tab = document.getElementById('hoshino_tabbutton')
const tabHeight = tab ? tab.offsetHeight : 100
const sectionTop = section.getBoundingClientRect().top + window.pageYOffset - tabHeight
window.scrollTo({
top: sectionTop,
behavior: 'smooth'
})
}
}
}
</script>

<style scoped>
#hoshino_main {
position: relative;
width: 100%;
margin-top: -56px;
}

#hoshino_main_img {
width: 100%;
display: block;
}
#hoshino_main_img_mobile {
width: 100%;
display: none;
}

#hoshino_tabbutton {
position: relative;
width: 100%;
height: 100px;
background-color: #e3d7cb;
z-index: 9999;
}

.hoshino_tab_fixed {
position: fixed !important;
top: 0;
left: 0;
width: 100% !important;
z-index: 9999;
}

#hoshino_tab_placeholder {
width: 100%;
height: 100px;
background-color: #e3d7cb;
}

#hoshino_tab_ul {
width: 600px;
height: 100px;
background-color: #e3d7cb;
margin: 0 auto;
padding: 0;
display: flex;
list-style: none;
}

.hoshino_tab {
width: 200px;
height: 100px;
flex-shrink: 0;
display: block;
cursor: pointer;
}

.hoshino_tab img {
width: 100%;
height: 100%;
display: block;
}

.hoshino_section {
width: 100%;
}

#hoshino_sec1 {
position: relative;
padding-top: 50px;
width: 100%;
background-color: #ddcfc1;
overflow: hidden;
text-align: center;
}

#hoshino_sec1::before {
content: "";
position: absolute;
inset: 0;
width: 100%;
height: 100%;
background-image: url(../assets/img/hoshinoresort/sec1_bg.png);
background-position: center top;
background-repeat: no-repeat;
background-size: cover;
z-index: 0;
pointer-events: none;
}

#hoshino_sec1 > * {
position: relative;
z-index: 1;
}

#hoshino_sec1_title {
display: block;
margin: 30px auto 0 auto;
}

#hoshino_sec1_contents {
width: 100%;
display: flex;
flex-direction: column;
align-items: center;
}

.hoshino_sec1_link {
display: block;
}

#hoshino_sec1_img {
display: block;
}

#hoshino_auto_slider {
width: 100%;
overflow: hidden;
margin-top: 30px;
padding-bottom: 30px;
}

#hoshino_auto_track {
display: flex;
width: max-content;
gap: 20px;
animation: hoshinoAutoSlide 25s linear infinite;
}

.hoshino_auto_item {
width: 300px;
height: 300px;
flex-shrink: 0;
border-radius: 15px !important;
overflow: hidden;
background-color: #fe112d;
}

@keyframes hoshinoAutoSlide {
0% {
transform: translateX(0);
}
100% {
transform: translateX(calc(-50% - 10px));
}
}

#hoshino_sec1_bottom {
width: 100%;
height: 100px;
background-color: #fff;
}

#hoshino_sec1_bottom2 {
width: 100%;
height: 100px;
background-color: #ddcfc1;
}

#hoshino_sec2 {
width: 100%;
margin: 0;
padding: 0;
background-color: #e3d7cb;
overflow: hidden;
}

#hoshino_sec2_main {
position: relative;
width: 100%;
height: 900px;
overflow: visible;
}

#hoshino_sec2_carousel {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 1000px;
overflow: hidden;
background-color: #000;
}

.hoshino_sec2_slide {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
opacity: 0;
visibility: hidden;
transition: opacity 0.45s ease, visibility 0.45s ease;
}

.hoshino_sec2_slide.active {
opacity: 1;
visibility: visible;
}

.hoshino_sec2_background {
position: absolute;
inset: 0;
width: 100%;
height: 100%;
background-color: #ddcfc1;
overflow: hidden;
}
  .hoshino_sec2_background { background-color: #ddcfc1; }

.hoshino_sec2_background:not(:has(img)) {
background-color: #ddcfc1;
}

.hoshino_sec2_text_panel {
position: absolute;
top: 45%;
left: 7%;
transform: translateY(-50%);
width: 30%;
min-height: 360px;
padding: 55px 40px;
box-sizing: border-box;
background: rgba(49, 31, 13, 0.55);
backdrop-filter: blur(3px);
-webkit-backdrop-filter: blur(3px);
z-index: 10;
display: flex;
align-items: center;
border-radius: 15px;
}

.hoshino_sec2_text_inner {
width: 100%;
color: #fff;
text-align: left;
}

.hoshino_sec2_text_label {
display: block;
margin-bottom: 18px;
font-size: 18px;
font-weight: 600;
letter-spacing: 2px;
}

.hoshino_sec2_text_title {
margin: 0;
font-size: 42px;
font-weight: 700;
line-height: 1.3;
word-break: keep-all;
}

.hoshino_sec2_text_desc {
margin: 22px 0 0;
font-size: 18px;
line-height: 1.7;
word-break: keep-all;
}


.hoshino_sec2_arrow:hover {
background: rgba(0, 0, 0, 0.6);
}




#hoshino_sec2_cards {
position: absolute;
left: 50%;
bottom: 25px;
transform: translateX(-50%);
z-index: 30;
width: 1000px;
display: flex;
justify-content: center;
gap: 15px;
}

.hoshino_sec2_card {
position: relative;
width: 185px;
height: 100px;
padding: 0;
border: none;
border-radius: 12px;
background-color: #fff;
box-sizing: border-box;
overflow: hidden;
cursor: pointer;
box-shadow: 0 5px 15px rgba(0, 0, 0, 0.22);
transition: transform 0.2s ease, border-color 0.2s ease;
opacity: 0.8;
}

.hoshino_sec2_card:hover {
transform: translateY(-8px);
}

.hoshino_sec2_card.active {
border-color: #ddcfc1;
transform: translateY(-5px);
box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.hoshino_sec2_card_red {
position: absolute;
inset: 0;
width: 100%;
height: 100%;
background-color: #000;
}

.hoshino_sec2_card_content {
position: absolute;
inset: 0;
z-index: 2;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
color: #fff;
text-align: center;
}

.hoshino_sec2_card_content strong {
font-size: 24px;
line-height: 1.3;
}

.hoshino_sec2_card_content small {
margin-top: 7px;
font-size: 15px;
}

#hoshino_sec3 {
width: 100%;
margin: 0;
padding: 0;
background-color: #e3d7cb;
overflow: hidden;
}

#hoshino_sec3_main {
position: relative;
width: 100%;
height: 900px;
overflow: visible;
}

#hoshino_sec3_carousel {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 1000px;
overflow: hidden;
background-color: #000;
}

.hoshino_sec3_slide {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
opacity: 0;
visibility: hidden;
transition: opacity 0.45s ease, visibility 0.45s ease;
}

.hoshino_sec3_slide.active {
opacity: 1;
visibility: visible;
}

.hoshino_sec3_background {
position: absolute;
inset: 0;
width: 100%;
height: 100%;
background-color: #ddcfc1;
overflow: hidden;
}
  .hoshino_sec3_background { background-color: #ddcfc1; }

.hoshino_sec3_background:not(:has(img)) {
background-color: #ddcfc1;
}

.hoshino_sec3_text_panel {
position: absolute;
top: 50%;
left: 7%;
transform: translateY(-50%);
width: 30%;
min-height: 360px;
padding: 55px 60px;
box-sizing: border-box;
background: rgba(49, 31, 13, 0.55);
backdrop-filter: blur(3px);
-webkit-backdrop-filter: blur(3px);
z-index: 10;
display: flex;
align-items: center;
border-radius: 15px;
}

.hoshino_sec3_text_inner {
width: 100%;
color: #fff;
text-align: left;
}

.hoshino_sec3_text_label {
display: block;
margin-bottom: 18px;
font-size: 18px;
font-weight: 600;
letter-spacing: 2px;
}

.hoshino_sec3_text_title {
margin: 0;
font-size: 42px;
font-weight: 700;
line-height: 1.3;
word-break: keep-all;
}

.hoshino_sec3_text_desc {
margin: 22px 0 0;
font-size: 18px;
line-height: 1.7;
word-break: keep-all;
}


.hoshino_sec3_arrow:hover {
background: rgba(0, 0, 0, 0.6);
}




#hoshino_sec3_cards {
position: absolute;
left: 50%;
bottom: 25px;
transform: translateX(-50%);
z-index: 30;
width: 1000px;
display: flex;
justify-content: center;
gap: 15px;
}

.hoshino_sec3_card {
position: relative;
width: 185px;
height: 100px;
padding: 0;
border: none;
border-radius: 12px;
background-color: #fff;
box-sizing: border-box;
overflow: hidden;
cursor: pointer;
box-shadow: 0 5px 15px rgba(0, 0, 0, 0.22);
transition: transform 0.2s ease, border-color 0.2s ease;
opacity: 0.8;
}

.hoshino_sec3_card:hover {
transform: translateY(-8px);
}

.hoshino_sec3_card.active {
border-color: #ddcfc1;
transform: translateY(-5px);
box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.hoshino_sec3_card_red {
position: absolute;
inset: 0;
width: 100%;
height: 100%;
background-color: #000000;
opacity: 1;
}

.hoshino_sec3_card_content {
position: absolute;
inset: 0;
z-index: 2;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
color: #fff;
text-align: center;
}

.hoshino_sec3_card_content strong {
font-size: 24px;
line-height: 1.3;
}

.hoshino_sec3_card_content small {
margin-top: 7px;
font-size: 15px;
}

#hoshino_sec3_bottom {
background-color: #fe112d;
margin-top: 90px;
text-align: center;
height: 170px;
}

#hoshino_button_wrap {
padding-top: 50px;
}

#hoshino_button {
display: block;
background-color: #fff;
color: #fe112d;
font-weight: bold;
margin: 0 auto;
width: 250px;
height: 80px;
font-size: 1.2rem;
border-radius: 50px;
padding-top: 1.5rem;
transition: all 0.2s;
}

#hoshino_button:hover {
background-color: #3f2205;
color: #fff !important;
}

@media (max-width: 768px) {

  body {
    overflow-x: hidden;
  }

  html,
  body,
  #app,
  #hoshinoresorts {
    width: 100%;
    overflow-x: hidden;
  }

  /* MAIN */
  #hoshino_main {
    width: 100%;
    overflow: hidden;
    margin-top: 4.3rem;
  }

  #hoshino_main_img {
    display: none;
  }
  #hoshino_main_img_mobile {
    display: block;
    width: 100%;
    height: auto;
    object-fit: contain;
}

  /* =========================================
     MOBILE ONLY IMAGE
     SEC2 / SEC3는 메인처럼 모바일 이미지를 별도 지정
     크기와 위치도 모바일에서만 조절 가능
  ========================================= */
  .hoshino_sec2_img_pc,
  .hoshino_sec3_img_pc {
    display: none !important;
  }

  .hoshino_sec2_img_mobile,
  .hoshino_sec3_img_mobile {
    display: block !important;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center center;
  }

  /* 모바일 이미지 크기 조절 */
  .hoshino_sec2_img_mobile {
    width: 100%;
    height: 100%;
  }

  .hoshino_sec3_img_mobile {
    width: 100%;
    height: 100%;
  }


  /* TAB */
  #hoshino_tabbutton {
    height: auto;
  }

  .hoshino_tab_fixed {
    position: fixed !important;
    top: 0;
    left: 0;
    width: 100%;
  }

  #hoshino_tab_placeholder {
    height: auto;
  }

  #hoshino_tab_ul {
    width: 100% !important;
    height: auto !important;
  }

  .hoshino_tab {
    width: 33.3333% !important;
    height: auto;
  }

  .hoshino_tab img {
    width: 100%;
    height: auto;
    display: block;
  }

  /* SEC1 */
  #hoshino_sec1 {
    width: 100%;
    height: auto;
    min-height: 0;
    padding: 20px 0 30px;
    background-color: #ddcfc1;
  }

  #hoshino_sec1_contents {
    width: 100%;
  }

  #hoshino_sec1_img {
    width: 100%;
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }

  #hoshino_auto_slider {
    width: 100%;
    margin-top: 20px;
    padding-bottom: 20px;
  }

  #hoshino_auto_track {
    gap: 10px;
    animation-duration: 20s;
  }

  .hoshino_auto_item {
    width: 200px;
    height: 200px;
    flex-shrink: 0;
  }

  .hoshino_auto_item img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  #hoshino_sec1_bottom {
    height: 60px;
  }

  #hoshino_sec1_bottom2 {
    height: 60px;
  }

  /* SEC2 */
  #hoshino_sec2 {
    width: 100%;
    height: auto;
    padding: 0;
    background-color: #e3d7cb;
  }

  #hoshino_sec2_main {
    width: 100%;
    height: 760px;
  }

  #hoshino_sec2_carousel {
    width: 100%;
    height: 760px;
  }

  .hoshino_sec2_background {
    width: 100%;
    height: 100%;
  }

  .hoshino_sec2_background img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    background-color: #ddcfc1;
  }

  .hoshino_sec2_text_panel {
    top: 38%;
    left: 5%;
    transform: translateY(-50%);
    width: 90%;
    min-height: 0;
    max-height: 560px;
    padding: 25px 22px;
    box-sizing: border-box;
    border-radius: 12px;
    background: rgba(49, 31, 13, 0.58);
    overflow: auto;
  }

  .hoshino_sec2_text_inner {
    width: 100%;
    text-align: left;
  }

  .hoshino_sec2_text_label {
    margin-bottom: 9px;
    font-size: 11px;
    letter-spacing: 1px;
  }

  .hoshino_sec2_text_title {
    font-size: 23px;
    line-height: 1.35;
    word-break: keep-all;
  }

  .hoshino_sec2_text_desc {
    margin-top: 12px;
    font-size: 13px;
    line-height: 1.6;
    word-break: keep-all;
  }

  #hoshino_sec2_cards {
    position: absolute;
    left: 50%;
    bottom: 15px;
    transform: translateX(-50%);
    width: 94%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    z-index: 30;
  }

  .hoshino_sec2_card {
    width: 100%;
    height: 65px;
    border-radius: 8px;
  }

  .hoshino_sec2_card_content {
    inset: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .hoshino_sec2_card_content strong {
    font-size: 16px;
    line-height: 1.3;
  }

  /* SEC3 */
  #hoshino_sec3 {
    width: 100%;
    height: auto;
    padding: 0;
    background-color: #e3d7cb;
  }

  #hoshino_sec3_main {
    width: 100%;
    height: 760px;
  }

  #hoshino_sec3_carousel {
    width: 100%;
    height: 760px;
  }

  .hoshino_sec3_background {
    width: 100%;
    height: 100%;
  }

  .hoshino_sec3_background img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    background-color: #e3d7cb;
  }

  .hoshino_sec3_text_panel {
    top: 42%;
    left: 5%;
    transform: translateY(-50%);
    width: 90%;
    min-height: 0;
    max-height: 390px;
    padding: 25px 22px;
    box-sizing: border-box;
    border-radius: 12px;
    background: rgba(49, 31, 13, 0.58);
    overflow: auto;
  }

  .hoshino_sec3_text_inner {
    width: 100%;
    text-align: left;
  }

  .hoshino_sec3_text_label {
    margin-bottom: 9px;
    font-size: 11px;
    letter-spacing: 1px;
  }

  .hoshino_sec3_text_title {
    font-size: 23px;
    line-height: 1.35;
    word-break: keep-all;
  }

  .hoshino_sec3_text_desc {
    margin-top: 12px;
    font-size: 13px;
    line-height: 1.6;
    word-break: keep-all;
  }

  #hoshino_sec3_cards {
    position: absolute;
    left: 50%;
    bottom: 15px;
    transform: translateX(-50%);
    width: 94%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    z-index: 30;
  }

  .hoshino_sec3_card {
    width: 100%;
    height: 65px;
    border-radius: 8px;
  }

  .hoshino_sec3_card_content {
    inset: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .hoshino_sec3_card_content strong {
    font-size: 16px;
    line-height: 1.3;
  }

  /* BOTTOM BUTTON */
  #hoshino_sec3_bottom {
    height: 130px;
    margin-top: 0;
  }

  #hoshino_button_wrap {
    padding-top: 25px;
  }

  #hoshino_button {
    width: 220px;
    height: 65px;
    font-size: 1rem;
    padding-top: 1.2rem;
  }

}

/* PC / MOBILE IMAGE SEPARATION */
.hoshino_sec2_img_pc,
.hoshino_sec3_img_pc {
  display: block !important;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: right center;
}

.hoshino_sec2_img_mobile,
.hoshino_sec3_img_mobile { display: none !important; }

@media (max-width: 768px) {
  .hoshino_sec2_img_pc,
  .hoshino_sec3_img_pc { display: none !important; }
  .hoshino_sec2_img_mobile,
  .hoshino_sec3_img_mobile {
    display: block !important;
    position: absolute;
    top: 0;
    left: 0;
    right: auto;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
}


/* MAIN UNDER */
.hoshino_main_under {
  width: 100%;
  height: 700px;
  background-color: #ffdab4;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
}

.hoshino_main_under_point {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.hoshino_main_under_point img {
  display: block;
  max-width: 100%;
  height: auto;
}

.hoshino_main_under_boxes {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 60px;
  flex-wrap: nowrap;
}

.hoshino_main_under_boxes img {
  display: block;
  max-width: 100%;
  height: auto;
  flex: 0 1 auto;
  transition: all 0.2s;
}
.hoshino_main_under_boxes img:hover{
  transform: translateY(-8px);
}

@media (max-width: 768px) {
  .hoshino_main_under {
    height: auto;
    min-height: 700px;
    padding: 0 15px 0px;
  }

  .hoshino_main_under_point {
    width: 100%;
    justify-content: center;
  }

  .hoshino_main_under_point img {
    width: auto;
    max-width: 80%;
    height: auto;
  }

  .hoshino_main_under_boxes {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 15px;
    margin-top: 45px;
    justify-items: center;
  }

  .hoshino_main_under_boxes img {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
}

</style>